import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual, batch } from 'react-redux';
import * as MailActions from '../../actions/mail';
import { SelectedRecordItem } from '../selectedRecordContainer/SelectedRecordItem';
import { SelectedRecordContainerContext } from '../selectedRecordContainer/SelectedRecordContainer';
import { Accordion } from '../accordion/Accordion';
import './Timeline.scss';

export const Timeline = () => {
  const dispatch = useDispatch();
  const context = useContext(SelectedRecordContainerContext);
  const mail = useSelector((state) => state.mail, shallowEqual);
  const { emailSubject, timelineSubject, settings, isSavingToTimeline, isSavingToTimelineByDefault } = mail;
  const subject = timelineSubject || emailSubject || '(No Subject)';
  const selectEmailRecordsByDefault = settings?.timelineSettings?.selectEmailRecordsByDefault;
  const saveAllEmailRecords = settings?.timelineSettings?.saveAllEmailRecords;
  const displayEmailRecords = settings?.timelineSettings?.displayEmailRecords;
  const timeToSave = (useSelector((state) => state.time.timeRecords) || []).filter((t) => !t.saved);
  const selectedRecords = useSelector((state) => state.mail.selectedRecords);
  const [isExpanded, setIsExpanded] = useState(true);

  const setSubjectAction = (newSubject) => {
    dispatch(MailActions.setTimelineSubject(newSubject));
  };

  const allEmailsSaved = Object.values(selectedRecords || {}).every((record) => record.emailMessageRecordSaved);

  useEffect(() => {
    const shouldSaveTimeline = selectEmailRecordsByDefault || saveAllEmailRecords || isSavingToTimeline;
    if ((shouldSaveTimeline && isSavingToTimeline === isSavingToTimelineByDefault && !allEmailsSaved) || timeToSave.length) {
      batch(() => {
        dispatch(MailActions.savingToTimeline(true));
        dispatch(MailActions.savingToTimelineDefault(true));
      });
    }
  }, [selectEmailRecordsByDefault, saveAllEmailRecords]);


  return (
    <div id="outlook-folder-component" className={displayEmailRecords ? '' : 'hide'}>
      <Accordion title='Activity Timeline' status={isExpanded} setStatus={setIsExpanded} />
      {
        isExpanded && <SelectedRecordItem
          nameProp={subject}
          itemId={context.emailId}
          imgSrc="/assets/activityTimeline.svg"
          savedState={(allEmailsSaved || !!timeToSave.length) }
          editCallback={setSubjectAction}
          showPopOut={!context.isComposingEmail && allEmailsSaved}
        />
      }
    </div>
  );
};
